export default __webpack_public_path__ + "static/media/carousel-mobile-3.9a1db981.jpg";